if (!window.Eurus.loadedScript.has('featured-collection.js')) {
  window.Eurus.loadedScript.add('featured-collection.js');

  requestAnimationFrame(() => {
    document.addEventListener('alpine:init', () => {
      Alpine.data('xFeaturedCollection', (sectionId, pageParam, container) => ({
        sectionId: sectionId,
        pageParam: pageParam,
        currentTab: 1,
        loading: true,
        loaded: [],
        visibleCount: {},
        totalCount: {},
        blockByIndex: {},
        init() {
          if (container) {
            container.addEventListener('fc:load-more', () => {
              this.loadMoreCurrent();
            });
          }
          this.updateHasMore();
        },
        select(index) {
          this.currentTab = index;
          this.updateHasMore();
        },
        initLoadMore(index, blockId, initialCount, totalCount) {
          if (this.visibleCount[blockId] === undefined) {
            this.visibleCount[blockId] = initialCount;
            this.totalCount[blockId] = totalCount;
          }
          this.blockByIndex[index] = blockId;
          this.updateHasMore();
        },
        isVisible(blockId, index) {
          if (this.visibleCount[blockId] === undefined) return true;
          return index <= this.visibleCount[blockId];
        },
        hasMore(blockId) {
          if (this.totalCount[blockId] === undefined) return false;
          return this.visibleCount[blockId] < this.totalCount[blockId];
        },
        hasMoreCurrent() {
          const blockId = this.blockByIndex[this.currentTab];
          if (!blockId) return false;
          return this.hasMore(blockId);
        },
        loadMore(blockId) {
          if (this.totalCount[blockId] === undefined) return;
          this.visibleCount[blockId] = this.totalCount[blockId];
          this.updateHasMore();
        },
        loadMoreCurrent() {
          const blockId = this.blockByIndex[this.currentTab];
          if (!blockId) return;
          this.loadMore(blockId);
        },
        loadData(index) {
          const selectedPage = index - 1;
          if (!this.loaded.includes(selectedPage)) {
            this.loading = true;
            
            let url = `${window.location.pathname}?section_id=${this.sectionId}&${this.pageParam}=${index}`;
            fetch(url, {
              method: 'GET'
            }).then(
              response => response.text()
            ).then(responseText => {
              const html = (new DOMParser()).parseFromString(responseText, 'text/html');
              const contentId = `x-fc-${this.sectionId}-${index}`;
              const newContent = html.getElementById(contentId);
              if (newContent && !document.getElementById(contentId)) {
                container.appendChild(newContent);
                this.loaded.push(selectedPage);
              }
              this.loading = false;
            })
          }
        },
        updateHasMore() {
          if (!container) return;
          container.dataset.fcHasMore = this.hasMoreCurrent() ? 'true' : 'false';
        },
        scrollIntoView(element) {
          const scrollableContainer = element.closest('.overflow-x-auto'); 
          const elementPosition = element.offsetLeft;

          scrollableContainer.scroll({
            left: elementPosition,
            behavior: 'smooth'
          });
        }
      }));
    });
  });
}
